// Hardcoded option lists for editable order-level dropdowns. Sourced from the
// legacy CMS templates; kept in sync by hand. The chassis-type compatibility
// regex in utils/chassisValidation.ts assumes specific values from these
// lists — keep them in sync when adding new entries.

export const EQUIPMENT_SIZES: ReadonlyArray<string> = [
  '',
  '20',
  '24',
  '27',
  '40',
  '45',
  '48',
  '53',
  '57',
];

// Equipment types within the "standard" family — interchangeable on
// existing orders. The equipType field is editable only when the order's
// saved value is one of these, and the only allowed targets are these
// three values. This is a stricter subset of EQUIPMENT_TYPES; non-family
// orders (REEFER, ISO TANK, etc.) cannot have their type changed by
// dispatchers from this surface.
export const STANDARD_EQUIP_FAMILY: ReadonlyArray<string> = [
  'STANDARD',
  'HIGHCUBE',
  'STD/HC',
];

export const EQUIPMENT_TYPES: ReadonlyArray<string> = [
  '',
  'CHASSIS',
  'DOUBLE DROP TRAILER',
  'FLATBED',
  'FLATBED WITH TARP',
  'FLATRACK',
  'FLATRACK HC',
  'HARDTOP',
  'HARDTOP HC',
  'HIGHCUBE',
  'HOPPER BOTTOM',
  'HOPPER CAR',
  'ISO TANK',
  'OPENTOP',
  'OPENTOP HC',
  'PLATFORM',
  'PNEUMATIC VAN',
  'RAILCAR',
  'REEFER',
  'REEFER HC',
  'REEFER VAN',
  'SEABULK',
  'STANDARD',
  'SINGLE DROP TRAILER',
  'STD/HC',
  'VAN',
];

export const CHASSIS_TYPES: ReadonlyArray<string> = [
  '',
  'COMBO',
  'DOUBLE DROP',
  'FLATBED',
  'MAFI',
  '48 SINGLE DROP',
  '53 SINGLE DROP',
  'SLIDER',
  'STANDARD',
  'SUPER LIGHT',
  'TANK CHASSIS',
  'TRIAXLE',
  '93K TRIAXLE',
  'ULTRA LIGHT',
];
// Order-level move types (legacy defs.pl @impexparray). The import/export/etc.
// classification stored on an order (edi_orders.movetype, orders.movetype), distinct
// from the pro-leg move types (PICKUP/DELIVERY/TERMINATE…) in LegsGrid. Stored
// uppercase; render Title-Cased. (Several pages still hold ad-hoc subsets — prefer
// this canonical list going forward.)
export const ORDER_MOVE_TYPES: ReadonlyArray<string> = [
  'DOMESTIC',
  'EXPORT',
  'IMPORT',
  'INBOUND',
  'OUTBOUND',
  'RAIL TO PORT',
  'REPO',
];

// Melrose Template Mapping: the only two customercodes for which the Bill To field is
// editable (V1 melrose_templatemap rule). The customers are otherwise unrelated —
// grouped solely by this UI gate.
export const MELROSE_BILLTO_CUSTOMERCODES: ReadonlyArray<string> = ['5925', '5860'];
